<template lang="pug">
  .credits
    p
      span(v-for="(item, index) in credits") {{item.title}}: <strong>{{item.author}}</strong> &nbsp;

</template>
<script>
export default {
  props: {
    credits: Array
  }
}
</script>
<style lang="scss" scoped>
  .credits{
    margin: 0 auto;
    text-align: center;
  }
  p{
    text-indent: 0;
    font-family: 'Open Sans', sans-serif;
      margin: 0;
      padding: 0;
      font-size: 1rem;
  }
</style>a